export const ENTERED_USER_DETAILS_KEY = 'enteredUserDetails';
